var map = {
	"./ar.json": 889,
	"./de.json": 890,
	"./en.json": 891,
	"./es.json": 892,
	"./fr.json": 893,
	"./it.json": 894,
	"./ja.json": 895,
	"./nl.json": 896,
	"./pt.json": 897,
	"./zh.json": 898
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 596;